import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Select2MultipleDirective } from '@teem/directives/select2-multiple.directive';
import { DateDropperDirective } from '@teem/directives/date-dropper.directive';
import { BasicTableDirective } from '@teem/directives/basic-table.directive';
import { ColorPickerDirective } from '@teem/directives/color-picker.directive';
import { Select2Directive } from '@teem/directives/select2.directive';
import { PreventScrollDirective } from '@teem/directives/prevent-scroll.directive';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { ShortNumberPipe } from '@teem/pipes/short-number.pipe';
import { FileSizePipe } from '@teem/pipes/filesize.pipe';
import { SafePipe } from '@teem/pipes/safe.pipe';
import { TimezonePipe } from '@teem/pipes/timezone.pipe';
import { RemoveUnderscorePipe } from '@teem/pipes/remove-underscore.pipe';
import { LazyLoadDirective } from '@teem/directives/lazy-load.directive';


@NgModule({
  declarations: [
    DateDropperDirective,
    BasicTableDirective,
    FileSizePipe,
    ColorPickerDirective,
    Select2Directive,
    UserCurrencyPipe,
    ShortNumberPipe,
    SafePipe,
    TimezonePipe,
    Select2MultipleDirective,
    RemoveUnderscorePipe,
    PreventScrollDirective,
    LazyLoadDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DateDropperDirective,
    BasicTableDirective,
    FileSizePipe,
    ColorPickerDirective,
    Select2Directive,
    Select2MultipleDirective,
    PreventScrollDirective,
    LazyLoadDirective,
    UserCurrencyPipe,
    ShortNumberPipe,
    SafePipe,
    TimezonePipe,
    RemoveUnderscorePipe
  ]
})
export class CoreModule { }